import type { FC } from "react";
import { defaultColor } from "../constants";
import type { IconProps } from "./types";
export const Contact: FC<IconProps> = ({
  color = defaultColor,
  height = 24,
}) => (
  <svg
    width="25"
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9569 9.40381C19.9569 10.0863 19.6858 10.7409 19.2032 11.2235C18.7206 11.7062 18.066 11.9773 17.3835 11.9773C16.7009 11.9773 16.0463 11.7062 15.5637 11.2235C15.0811 10.7409 14.81 10.0863 14.81 9.40381C14.81 8.72128 15.0811 8.0667 15.5637 7.58408C16.0463 7.10146 16.7009 6.83032 17.3835 6.83032C18.066 6.83032 18.7206 7.10146 19.2032 7.58408C19.6858 8.0667 19.9569 8.72128 19.9569 9.40381Z"
      fill={color}
    />
    <path
      d="M15.8404 15.3333H16.2347C16.2347 14.501 15.9772 13.6808 15.4887 13.0067H19.9569C20.3663 13.007 20.7587 13.1825 21.0481 13.4946C21.3374 13.8067 21.5 14.2299 21.5 14.6711C21.5 14.6711 21.5 18 17.3824 18C16.7077 18 16.1435 17.9106 15.6715 17.7611C15.9048 17.238 16.0392 16.7485 16.1177 16.3576C16.1741 16.0764 16.2032 15.8379 16.2183 15.6624C16.2258 15.5743 16.2299 15.5013 16.2322 15.4459C16.2333 15.4181 16.2339 15.3947 16.2343 15.3758L16.2347 15.351L16.2347 15.3413L16.2347 15.3371L16.2347 15.3352C16.2347 15.3352 16.2347 15.3344 15.8404 15.3339V15.3333Z"
      fill={color}
    />
    <path
      d="M3.5 15.3333C3.5 14.7145 3.72546 14.121 4.12678 13.6834C4.5281 13.2458 5.0724 13 5.63995 13H12.5948C13.1623 13 13.7066 13.2458 14.108 13.6834C14.5093 14.121 14.7347 14.7145 14.7347 15.3333C14.7347 15.3333 14.7347 20 9.11737 20C3.5 20 3.5 15.3333 3.5 15.3333Z"
      fill={color}
    />
    <path
      d="M12.9945 7.87715C12.9945 10.0184 11.2587 11.7543 9.11738 11.7543C6.97609 11.7543 5.24023 10.0184 5.24023 7.87715C5.24023 5.73586 6.97609 4 9.11738 4C11.2587 4 12.9945 5.73586 12.9945 7.87715Z"
      fill={color}
    />
  </svg>
);
